import { TimeSlotsApi, TimeSlots } from '../models';

export function mapTimeSlotsApiToModel(timeSlotsApi: TimeSlotsApi): TimeSlots {
  return {
    id: timeSlotsApi.id,
    externalId: timeSlotsApi.externalId,
    code: timeSlotsApi.code,
    dateTimeFrom: timeSlotsApi.dateTimeFrom,
    dateTimeTo: timeSlotsApi.dateTimeTo,
    logisticOperatorId: timeSlotsApi.logisticOperatorId,
    expiration: timeSlotsApi.expiration,
    active: timeSlotsApi.active,
    mo: timeSlotsApi.mo,
    tu: timeSlotsApi.tu,
    we: timeSlotsApi.we,
    th: timeSlotsApi.th,
    fr: timeSlotsApi.fr,
    sa: timeSlotsApi.sa,
    su: timeSlotsApi.su,
    createdAt: timeSlotsApi.createdAt,
    updatedAt: timeSlotsApi.updatedAt,
  };
}
